import React from "react";
import { projectGroups, projects } from "../../data/projects";
import { nodeId } from "../../data/connections";
import EvidenceCard from "../../components/investigation/EvidenceCard";
import EvidenceImage from "../../components/investigation/EvidenceImage";
import { detailFromProject } from "../../utils/evidenceDetail";

const ROTATIONS = [-1.2, 0.8, -0.5, 1.4, -0.9];
const PINS = ["red", "black", "brass"];

const byId = Object.fromEntries(projects.map((project) => [project.id, project]));

const ProjectCard = ({ project, index }) => (
  <EvidenceCard
    variant="polaroid"
    pin={PINS[index % PINS.length]}
    rotate={ROTATIONS[index % ROTATIONS.length]}
    className="project-evidence"
    nodeId={nodeId.project(project.id)}
    detail={detailFromProject(project)}
  >
    <EvidenceImage
      src={project.image}
      alt=""
      variant={project.imageKind === "document" ? "document" : "screenshot"}
      placeholderLabel={project.placeholderLabel || "PROJECT SCREENSHOT"}
      pin={false}
    />
    <div className="project-evidence-body">
      <div className="project-evidence-meta">
        <span>Exhibit {project.evidenceNo}</span>
        {project.withTeam ? <span className="tag">team</span> : null}
        {project.videos?.length ? <span className="tag">▶ video</span> : null}
      </div>
      <h3>{project.title}</h3>
      <p className="project-role">{project.role}</p>
      <p className="project-copy">{project.description}</p>
      <p className="project-stack">{project.stack.join(" · ")}</p>
      <span className="exhibit-link">pull the file ↗</span>
    </div>
  </EvidenceCard>
);

export const ProjectsSection = () => (
  <div className="projects-cluster">
    {projectGroups.map((group) => (
      <div key={group.id} className="evidence-group">
        <p className="evidence-group-label">
          Built with {group.label} <span>· {group.ids.length} exhibits</span>
        </p>
        <div className="evidence-group-row projects-row">
          {group.ids.map((id, index) => {
            const project = byId[id];
            if (!project) return null;
            return <ProjectCard key={id} project={project} index={index} />;
          })}
        </div>
      </div>
    ))}
  </div>
);

export default ProjectsSection;
